import { useProfileStore } from 'stores/profile-store';
import { TNormalizedPeopleUnit, TNormalizedUnit } from 'types';
import { UNIT_MEMBERSHIP_TYPE } from 'boot/constants';

export function memberOfUnit(unitToTest: TNormalizedUnit): boolean {
  const profileStore = useProfileStore();
  const units = profileStore.getUnits();
  return units.some(
    (unit: TNormalizedPeopleUnit) =>
      unit.id === unitToTest.id &&
      unit.membership_type_id !== undefined &&
      [
        UNIT_MEMBERSHIP_TYPE.SUBSCRIBING,
        UNIT_MEMBERSHIP_TYPE.HONORARY,
      ].includes(unit.membership_type_id)
  );
}
